var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeartIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 27,
    viewBox: "0 0 30 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.9952 4.03337C25.3599 3.38873 24.6056 2.87736 23.7754 2.52847C22.9451 2.17958 22.0553 2 21.1566 2C20.258 2 19.3681 2.17958 18.5379 2.52847C17.7077 2.87736 16.9534 3.38873 16.3181 4.03337L14.9997 5.37059L13.6812 4.03337C12.398 2.73186 10.6575 2.00067 8.84269 2.00067C7.0279 2.00067 5.28743 2.73186 4.00418 4.03337C2.72092 5.33488 2 7.1001 2 8.94072C2 10.7813 2.72092 12.5466 4.00418 13.8481L5.32264 15.1853L14.9997 25L24.6767 15.1853L25.9952 13.8481C26.6307 13.2037 27.1349 12.4387 27.4789 11.5967C27.8229 10.7547 28 9.85216 28 8.94072C28 8.02928 27.8229 7.12677 27.4789 6.28475C27.1349 5.44273 26.6307 4.6777 25.9952 4.03337V4.03337Z",
    stroke: "#4676FA",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartIcon);
export default __webpack_public_path__ + "static/media/heart-icon.2553e9ca378dd934cbe4edd83bdfbdff.svg";
export { ForwardRef as ReactComponent };